/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-19 16:29:29
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-11-01 11:42:17
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DropdownHOC/index.tsx
 */
import React from 'react';
import css from './css.module.less';
import DropDown from '@/src/components/Antd/DropDown/DropDown';

const HOCWrapper = (Trigger, Items) => {
  const FilterDrop = (props) => {
    const [visible, setVisible] = React.useState(false);

    const { dropdownProps = {}, ...rest } = props;
    const { maxWidth, maxHeight, triggerContainer } = dropdownProps;
    return (
      <DropDown
        // onClick={(e) => {
        //   console.log('clickl');
        // }}
        getPopupContainer={() => document.body}
        visible={visible}
        onVisibleChange={setVisible}
        className={css.filterDrop}
        maxWidth={maxWidth || 300}
        maxHeight={maxHeight || 300}
        overlay={
          <div className={css.contentContainer}>
            <Items
              {...rest}
              onDropDownChange={setVisible}
              dropDownVisible={visible}
            />
          </div>
        }
        trigger={['click']}>
        <div className={`${css.triggerContainer} ${triggerContainer || ''}`}>
          <Trigger {...rest} />
        </div>
      </DropDown>
    );
  };
  return FilterDrop;
};

export default HOCWrapper;
